document.addEventListener('DOMContentLoaded', function () {
  const products = document.querySelectorAll(
    '.product-card, .card, .card-wrapper'
  );

  if (!products.length) return;

  products.forEach(function (product, index) {
    product.classList.add('scroll-reveal-product');

    // Subtle stagger between products
    product.style.transitionDelay = `${Math.min(index * 70, 280)}ms`;
  });

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -40px 0px'
  });

  products.forEach(function (product) {
    observer.observe(product);
  });
});
